import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { GridPaginationModel } from '@mui/x-data-grid';

import { QueryRenderer } from '@barboxx/admin-components';
import { usePaging } from '@barboxx/admin-utils';
import Api from '@barboxx/api';

import { RootContainer } from '../../components/nav/RootContainer';
import SignupTable from './component/SignupTable';

export default function SignupList() {
    const navigate = useNavigate();

    const { page, size, updatePageModel } = usePaging();

    const signupResults = useQuery({
        queryKey: ['signups', page, size],
        queryFn: () => Api.Businesses.getSignups({ page, size }),
    });

    const handleChangePage = (pageModel: GridPaginationModel) => {
        updatePageModel(pageModel);
    };

    const handleRowClick = (id: string) => {
        navigate(`${id}`);
    };

    return (
        <RootContainer maxWidth={false}>
            <QueryRenderer results={signupResults}>
                {data => (
                    <SignupTable
                        data={data?.results ?? []}
                        paginationModel={{
                            page,
                            pageSize: size,
                        }}
                        rowCount={data?.results.length}
                        onPaginationModelChange={handleChangePage}
                        onRowClick={handleRowClick}
                    />
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
